module.exports = __webpack_public_path__ + "img/p447.32ac6138.jpg";